'use client';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';
import LeftIcon from '@/icons/left.svg';

type Props = { scrollTo?: string; disabled: boolean };

function PreviousLink(props: Props) {
  const { scrollTo, disabled } = props;

  const searchParams = useSearchParams();
  const params = new URLSearchParams(searchParams);

  const page = searchParams.get('page') ?? '1';
  const previousPage = parseInt(page) - 1;

  params.set('page', previousPage.toString());

  // https://www.scottohara.me/blog/2021/05/28/disabled-links.html
  if (disabled) {
    return (
      <a role='link' className='pagination__link' aria-disabled={true}>
        <LeftIcon width={24} height={24} />
      </a>
    );
  }

  return (
    <Link
      href={`?${params.toString()}#${scrollTo}`}
      aria-label={`Vorherige Seite, Seite ${previousPage}`}
      className='pagination__link'
    >
      <LeftIcon width={24} height={24} />
    </Link>
  );
}

export default PreviousLink;
